import { faUser } from "@jewlr/pro-light-svg-icons/faUser"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { Suspense } from "react"

import setDropdown from "areas/header/hoc/set-dropdown"
import NavIcon from "areas/header/nav-icon"
import Button from "components/ui/button"
import { retry } from "helpers/application"
import { cn } from "styles/utils"

const AccountDropdown = loadable(
  () => retry(() => import("./account-dropdown")),
  { ssr: false }
)

const AccountIcon = ({ buttonProps, loggedIn, showDropdown }) => (
  <>
    <Button {...buttonProps}>
      <div
        className={cn(
          "block",
          showDropdown && "hover:text-primary hover:font-medium",
          showDropdown &&
            "before:border-9 tablet:before:-bottom-14 before:absolute before:-bottom-2 before:z-30 before:block before:h-0 before:w-0 before:border-b-white before:border-l-transparent before:border-r-transparent before:border-t-transparent",
          showDropdown &&
            "after:border-9 after:border-b-grey-10 tablet:after:-bottom-12 after:absolute after:bottom-0 after:z-20 after:block after:h-0 after:w-0 after:border-l-transparent after:border-r-transparent after:border-t-transparent"
        )}
      >
        <NavIcon data-cy="header-account-icon-desktop" icon={faUser} />
      </div>
    </Button>
    {typeof window !== "undefined" && (
      <Suspense fallback={<div />}>
        {loggedIn && showDropdown && <AccountDropdown />}
      </Suspense>
    )}
  </>
)

AccountIcon.propTypes = {
  buttonProps: PropTypes.object,
  loggedIn: PropTypes.bool,
  showDropdown: PropTypes.bool,
}

export default setDropdown(AccountIcon)
